const EXTRA = 50;

export const BREAKPOINT_XS = 0;
export const BREAKPOINT_SM = 576 + EXTRA;
export const BREAKPOINT_MD = 768 + EXTRA;
export const BREAKPOINT_LG = 992 + EXTRA;
export const BREAKPOINT_XL = 1200 + EXTRA;
export const BREAKPOINT_XXL = 1400 + EXTRA;
